// @react
import React, { ReactElement } from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import MembershipContainer from 'modules/onBoarding/components/Membership'

const Membership = (): ReactElement => {
  return (
    <DocumentTitle title={`Step 8 - Become A Member | ATD`}>
      <MembershipContainer />
    </DocumentTitle>
  )
}

export default Membership
